import React, {useEffect} from 'react'
import Login from '../shared/login'
import {fetchAdminLogin, loginSelector} from '../api/authSlice'
import { useDispatch, useSelector } from 'react-redux'
import Backgroundimage from '../../components/images/img1.jpg'
import Logo from '../images/SonaLogo.png'
import {
    Layout,
    Button,
    Row,
    Col,
    Form,
    Input,
  } from "antd";




export default function Adminlogin({history}) {


    const dispatch = useDispatch()
const {isAdminAuthenticate, loading} = useSelector(loginSelector)



    useEffect(()=>{

        if (!isAdminAuthenticate) {
            history.push('/');
          }
          else{
    
            history.push('/admin/home');
          }
    
    }, [isAdminAuthenticate])

    
        const onFinish = values => {
        console.log('Received values of form: ', values);
        dispatch(fetchAdminLogin(values))
        };

        const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        };
 

    return (
        <Layout className=" " >
        <Row glutter={14}>
        <Col span={14} 
        style={{  display: 'flex', justifyContent: 'center', alignItems: 'center', height:'100vh' }}
        >
          <img src={Backgroundimage} alt='img' style={{ width: "100%", height: '100%', backgroundSize: 'cover'}}/>
          </Col>
            <Col
            span={10}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:'100%' }}
            >
              <div>
              <img src={Logo} alt='Logo' style={{ width: "auto", height: '120px', display: 'block', marginLeft: 'auto', marginRight: 'auto', }}/>
              <div style={{}}>
              <br/>
              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                className="row-col"
              >

         <h1 style={{  fontSize:"28px", fontWeight:'bold', marginBottom:'0px' }}>Admin</h1>
         <p  style={{  fontSize:"15px", marginBottom:'20px',  }}>Login to continue</p>

         <br/>

                <Form.Item
                  
                  label="Email"
                  name="email"
                  style={{borderColor: 'white', }}
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                  
                >
                  <Input  id="email" name="email" type="email"  autocomplete="email" required="" placeholder="Your Email" style={{height:'44px', width:'350px'}} />
                </Form.Item>



                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      
                      message: "Please input your password!",
                    },
                  ]}
                  for="password"> 
                  <Input.Password id="password" name="password" type="password" autocomplete="current-password" required="" placeholder="Password" style={{height:'44px', width:'350px'}}/>
                </Form.Item>


                <br/>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    value="Login"
                    style={{ width: "100%", height:'44px' }}
                  >
                   Log In
                  </Button>
                </Form.Item>
              </Form>
              </div>
              </div>
    </Col>
    
  </Row>
      </Layout>
    )
}
